import { createI18n } from "vue-i18n";
import Cookies from 'js-cookie'
import en from '@/i18n/locales/en.js'
import it from '@/i18n/locales/it.js'
const savedLocale = Cookies.get('locale') || 'en'

const messages = {
  en: en,
  it: it,
}

export const i18n = createI18n({
  legacy:false,
  locale: savedLocale,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  globalInjection: true,
  messages: messages
})

